import { render, staticRenderFns } from "./Dashboard5.vue?vue&type=template&id=976a54ea&scoped=true"
import script from "./Dashboard5.vue?vue&type=script&lang=js"
export * from "./Dashboard5.vue?vue&type=script&lang=js"
import style0 from "./Dashboard5.vue?vue&type=style&index=0&id=976a54ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976a54ea",
  null
  
)

export default component.exports